module.exports = __webpack_public_path__ + "img/knzb-thumb.f10851b4.jpg";